import log from '@atlassian/jira-common-util-logging/src/log.tsx';
/**
 * Determines if a given date happened within the last 7 days
 * @param dateString - Date string in ISO format (e.g., "2025-08-07T22:31:49.733257Z")
 * @param currentDate - Optional current date to compare against (defaults to new Date())
 * @returns boolean - true if the date is within the last 7 days, false otherwise
 */
export default function isWithinLast7Days(dateString: string, currentDate?: Date): boolean {
	// Parse the input date
	const inputDate = new Date(dateString);

	if (Number.isNaN(inputDate.getTime())) {
		log.safeErrorWithoutCustomerData(
			'jira-onboarding.utils.isWithinLast7Days',
			`Invalid date: ${dateString}`,
		);
		return false;
	}

	// Get current date (use provided date or create new one)
	const now = currentDate || new Date();

	// Calculate 7 days ago from now
	const sevenDaysAgo = new Date(now);
	sevenDaysAgo.setDate(now.getDate() - 7);

	// Check if the input date is between 7 days ago and now
	return inputDate >= sevenDaysAgo && inputDate <= now;
}
